<template>
  <section>
    <Banner value="Fale Conosco"/>
    <hr style="border:5px solid #DDD">

    <section style="background:#DDD;">
      <v-container grid-list-xl>
        <v-layout row wrap my-2>
          <v-flex xs12>
            <p
              class="lead"
            >Abaixo você encontra nossos telefones e email de contato. Aproveite também para nos chamar no WhatsApp e marcar uma visita. Estamos à sua disposição de segunda a sexta das 7 às 19 horas, exceto nos feriados.</p>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <section class="section">
      <h1 style="text-align:center; font-size:25px; line-height:1.1em;">
        <span style="font-size:45px;">Telefones</span>
        <br>Fixo, Celular e Whatsapp
      </h1>
      <v-container grid-list-xl>
        <v-layout align-start justify-space-around row fill-height wrap my-4>
          <v-flex sm12 md5 lg4 xl3 mb-4>
            <h2>
              <small>Telefone fixo</small>(48) 3237-2410
            </h2>
            <v-btn href="tel:(48) 3237-2410" block round large color="primary">
              <i class="fa-2x fas fa-phone"></i> Ligar para fixo
            </v-btn>
          </v-flex>
          <v-flex sm12 md5 lg4 xl3>
            <h2>
              <small>Telefone celular</small>(48) 99922-6535
            </h2>
            <v-btn href="tel:(48) 99922-6535" block round large color="orange" dark>
              <i class="fa-2x fas fa-mobile-alt"></i> Ligar para celular
            </v-btn>
            <v-btn
              href="https://wa.me/5548999226535?text=Ol%C3%A1!%20Cheguei%20aqui%20atrav%C3%A9s%20do%20site%20da%20Escola%20Engenho."
              block
              round
              large
              color="green"
              dark
            >
              <i class="fa-2x fab fa-whatsapp"></i> Mensagem de WhatsApp
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <section class="section" style="background:#EEEEEE">
      <v-container grid-list-xl>
        <v-layout align-start justify-space-around row fill-height wrap>
          <v-flex sm12 md6 style="text-align:center;" my-4>
            <h1 style="text-align:center; font-size:25px; line-height:1.1em;">
              <span style="font-size:45px;">Email</span>
              <br>Envie sua mensagem
            </h1>
            <br>
            <p class="lead">engenho@escolaengenho.com.br</p>
            <v-btn href="mailto:engenho@escolaengenho.com.br" round large color="primary">
              <i class="fa-2x far fa-envelope"></i> Enviar email
            </v-btn>
            <br>
            <br>
          </v-flex>
          <v-flex sm12 md6 style="text-align:center;" my-4>
            <h1 style="text-align:center; font-size:25px; line-height:1.1em;">
              <span style="font-size:45px;">Correios</span>
              <br>Nosso endereço
            </h1>
            <br>
            <p class="lead">
              Rua Valdomiro José Vieira, 94
              <br>Campeche - Florianópolis - SC
              <br>CEP 88063-035
            </p>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
  </section>
</template>

<script>
import Banner from "../../components/Banner";

export default {
  data: () => ({
    rota:
      "https://www.google.com/maps/place/Av.+Pequeno+Pr%C3%ADncipe,+1890+-+Campeche+Leste,+Florian%C3%B3polis+-+SC,+88063-245/@-27.682191,-48.4947549,922m/data=!3m1!1e3!4m5!3m4!1s0x95273b6914f0e8d3:0xe86924dee062b26!8m2!3d-27.6821958!4d-48.4925662",
    fone: "(48) 9 8805-8518",
    foneWhats:
      "https://wa.me/5548988058518?text=Ol%C3%A1!%20Cheguei%20aqui%20atrav%C3%A9s%20do%20site%20da%20Escola%20Engenho.",
    fone2: "(48) 9 9630-0608",
    fone2Whats:
      "https://wa.me/5548996300608?text=Ol%C3%A1!%20Cheguei%20aqui%20atrav%C3%A9s%20do%20site%20da%20Escola%20Engenho.",
    email: "banana.bacana@yahoo.com.br"
  }),
  components: {
    Banner
  }
};
</script>

<style lang="scss" scoped>
h2 {
  text-align: center !important;
}
i.fa-2x {
  margin-right: 10px;
}
</style>

